import { animate, stagger } from "motion";

const siteMenu = document.querySelector(".site-menu");

export default {
  init: () => {
    if (!siteMenu || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    const siteMenuHeader = siteMenu.querySelectorAll(".site-menu-header");
    const siteMenuShape = siteMenu.querySelector(".site-menu-shape");
    const siteMenuMenus = siteMenu.querySelectorAll(".site-menu-menu");

    document.documentElement.addEventListener("sitemenu:open", () => {
      const isMobile = !window.matchMedia("(min-width: 768px)").matches;

      animate([
        [siteMenuShape, { x: ["100%", 0], y: [isMobile ? 0 : "-100%", 0], opacity: [0, 1] }, { duration: 0.5 }],
        [siteMenuHeader, { y: ["30%", 0], opacity: [0, 1] }, { duration: 0.3, at: "<" }],
        ...Array.from(siteMenuMenus).map((menu) => {
          return [
            menu.querySelectorAll("li"),
            { y: ["40%", 0], opacity: [0, 1] },
            { duration: 0.2, delay: stagger(0.1), at: "<" },
          ];
        }),
      ]);
    });

    document.documentElement.addEventListener("sitemenu:close", () => {
      const isMobile = !window.matchMedia("(min-width: 768px)").matches;

      animate([
        [siteMenuHeader, { opacity: 0 }, { duration: 0.2 }],
        ...Array.from(siteMenuMenus).map((menu) => {
          return [menu.querySelectorAll("li"), { opacity: 0 }, { duration: 0.2, at: "<" }];
        }),
        [siteMenuShape, { x: "150%", y: [isMobile ? 0 : "-100%"] }, { duration: 0.5 }],
      ]);
    });
  },
};
